<template>
  <div>

    <md-card>

      <md-card-content>

        <p>
          セット名（英語）、セット名（日本語）、作成者、フィガーを入力してください。「*(アスタリスク)」が付いている項目は必須項目です。
        </p>

        <!-- イベントの名称 -->
        <md-input-container
          md-clearable
          v-show="!setNameError">
          <label>セット名（英語）</label>
          <md-input
            required
            v-model="setName"></md-input>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="setNameError"
          class="md-input-invalid">
          <label>セット名（英語）</label>
          <md-input
            required
            v-model="setName"></md-input>
          <span
            class="md-error"
            v-model="setNameError">{{ setNameError }}</span>
        </md-input-container>

        <!-- イベントの名称 -->
        <md-input-container
          md-clearable
          v-show="!setNameJPError">
          <label>セット名（日本語）</label>
          <md-input
            required
            v-model="setNameJP"></md-input>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="setNameJPError"
          class="md-input-invalid">
          <label>セット名（日本語）</label>
          <md-input
            required
            v-model="setNameJP"></md-input>
          <span
            class="md-error"
            v-model="setNameJPError">{{ setNameJPError }}</span>
        </md-input-container>

        <!-- 開催者 -->
        <md-input-container
          md-clearable
          v-show="!editerNameError">
          <label>作成者</label>
          <md-input
            required
            v-model="editerName"></md-input>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="editerNameError"
          class="md-input-invalid">
          <label>作成者</label>
          <md-input
            required
            v-model="editerName"></md-input>
          <span
            class="md-error"
            v-model="editerNameError">{{ editerNameError }}</span>
        </md-input-container>

        <md-input-container>
          <label>セットの説明</label>
          <md-textarea v-model="notices"></md-textarea>
        </md-input-container>

        <div>
          <md-radio
            v-model="typeOfEvnet"
            id="my-test1"
            name="type-of-evnet"
            md-value="Class">クラス</md-radio>
          <md-radio
            v-model="typeOfEvnet"
            id="my-test2"
            name="type-of-evnet"
            md-value="Céilí">ケーリー</md-radio>
          <md-radio
            v-model="typeOfEvnet"
            id="my-test2"
            name="type-of-evnet"
            md-value="SessionOrDance">セッション/ダンス</md-radio>
        </div>

      </md-card-content>

      <md-button
        id="addEvent"
        class="md-raised md-primary"
        @click="setEvent('dialog5')">セットを作成する</md-button>

    </md-card>

    <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @open="onOpen"
      @close="onClose"
      ref="dialog5">
    </md-dialog-confirm>

    <form
      novalidate
      @submit.stop.prevent="openErrorConsole">
      <md-snackbar
        :md-position="'top center'"
        ref="snackbar"
        :md-duration="4000">
        <span>{{ errorMessage }}</span>
      </md-snackbar>
    </form>

  </div>
</template>

<script>
import db from '../db'

// db.ref('/events').once('value').then(function (events) {
//   console.log(events.val())
// })
// db.ref('/events/').remove()

export default {
  name: 'event',
  data () {
    return {
      eventId: this.$route.params.eventId,
      setName: '',
      setNameJP: '',
      editerName: '',
      typeOfEvnet: 'Class',
      // url: '',
      notices: '',
      setNameError: '',
      setNameJPError: '',
      editerNameError: '',
      errorMessage: '',
      event: {},
      confirm: {
        title: '以下の内容でセットを作成します。よろしいですか？',
        contentHtml: 'content',
        ok: '作成する',
        cancel: 'キャンセル'
      }
    }
  },
  firebase: {
    allSets: db.ref('/sets')
  },
  computed: {
    getCurrentYear () {
      return new Date().getFullYear()
    },
    getCurrentMonth () {
      return new Date().getMonth()
    },
    getCurrentDate () {
      return new Date().getDate()
    }
  },
  methods: {
    setEvent (ref) {
      // <strong>anonymous</strong>
      let isError = false
      this.errorMessage = ''

      if (this.setName === '') {
        this.errorMessage += 'セット名（英語）を入力してください。'
        this.setNameError = 'セット名（英語）を入力してください。'
        isError = true
      } else {
        this.setNameError = ''
      }

      if (this.setNameJP === '') {
        this.errorMessage += 'セット名（日本語）を入力してください。'
        this.setNameJPError = 'セット名（日本語）を入力してください。'
        isError = true
      } else {
        this.setNameJPError = ''
      }

      if (this.editerName === '') {
        this.errorMessage += '作成者を入力してください。'
        this.editerNameError = '作成者を入力してください。'
        isError = true
      } else {
        this.editerNameError = ''
      }

      if (isError) {
        this.$refs.snackbar.open()
        return
      } else {
        this.errorMessage = ''
      }

      // let zeroFill = require('zero-fill')

      let typeOfEvent = ''

      switch (this.typeOfEvent) {
        case 'Ceili':
          typeOfEvent = 'ケーリー'
          break
        case 'Class':
          typeOfEvent = 'クラス'
          break
        case 'SessionOrDance':
          typeOfEvent = 'セッション/ダンス'
          break
        default:
          typeOfEvent = 'ケーリー'
          break
      }

      this.confirm.contentHtml = 'セット名：' + this.setName + '<br />作成者：' + this.editerName + '<br />イベントの種類：' + typeOfEvent + '<br />' + '<br />セットの説明：' + this.notices.replace(/\n/g, '<br/>')
      this.$refs[ref].open()
    },
    openDialog (ref) {
      this.$refs[ref].open()
    },
    closeDialog (ref) {
      this.$refs[ref].close()
    },
    onOpen () {
    },
    onClose (type) {
      if (type !== 'ok') { return }
      let self = this
      // let originalSetsRef = db.ref('/originalSets').push()
      let originalSetsRef = db.ref('/originalSets')

      originalSetsRef.child(this.setName).set({
        name: this.setName,
        jpCaption: this.setNameJP,
        county: [this.setName],
        notices: this.notices,
        editer: this.editerName,
        referenceSite: null,
        lastModifiedTime: Date.parse(new Date()) * -1,
        figures: {},
        type: this.typeOfEvnet
      }).then(function () {
        self.$router.push({ name: 'Set', params: { setName: self.setName } })
      })
      // .catch(function (error) {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.field-group {
  display: -webkit-flex; /* Safari */
  display: flex;
}
.md-input-container {
  /*display: flex;*/
}

h1, h2 {
  font-weight: normal;
}

.md-avatar.md-large {
  width: 113px;
  max-width: 113px;
  min-width: 113px;
}

.md-avatar {
  overflow: inherit;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  /*display: inline-block;*/
  margin: 0 10px;
}

a {
  color: #42b983;
}

#addEvent {
  margin: 24px 16px;
}
</style>



// WEBPACK FOOTER //
// AddSet.vue?7003e742